export const CAPABILITIES = {
  view_records:     'View collection records',
  change_status:    'Change record field values',
  approve:          'Approve or reject gate requests',
  view_kb:          'View knowledge base',
  edit_pipeline:    'Edit pipeline (nodes, edges, fields)',
  manage_members:   'Invite / remove members and change roles',
  manage_api_keys:  'Create and revoke API keys',
  run_workflows:    'Run manual triggers',
  view_reports:     'View reports and cost data',
};

export const ROLE_PRESETS = {
  owner: {
    label: 'Owner',
    description: 'Full access to everything',
    capabilities: Object.keys(CAPABILITIES),
  },
  admin: {
    label: 'Admin',
    description: 'Full access except transferring ownership',
    capabilities: Object.keys(CAPABILITIES),
  },
  editor: {
    label: 'Editor',
    description: 'Edit pipeline, manage records, run workflows',
    capabilities: [
      'view_records', 'change_status', 'approve', 'view_kb',
      'edit_pipeline', 'run_workflows', 'view_reports',
    ],
  },
  approver: {
    label: 'Approver',
    description: 'View records, approve gates, read KB',
    capabilities: [
      'view_records', 'approve', 'view_kb', 'view_reports',
    ],
  },
  service_desk: {
    label: 'Service Desk',
    description: 'View and update records, view KB',
    capabilities: [
      'view_records', 'change_status', 'view_kb',
    ],
  },
  viewer: {
    label: 'Viewer',
    description: 'Read-only access',
    capabilities: [
      'view_records', 'view_kb', 'view_reports',
    ],
  },
};

export function hasCapability(role, capability) {
  if (role === 'owner') return true;
  const preset = ROLE_PRESETS[role];
  if (!preset) return false;
  return preset.capabilities.includes(capability);
}

export function getRoleLabel(role) {
  return ROLE_PRESETS[role]?.label || role;
}
